// extracted by mini-css-extract-plugin
module.exports = {"container":"DataProtection-styles-container-b86fe2c8"};